import React from "react";
import { motion } from "framer-motion";
import { EXPERIENCES, IMAGES, EXPERIENCE_INTRO } from "../data";

const Experiences = () => {
  return (
    <section id="experiencia" className="relative py-24 md:py-32" style={{ background: "var(--ocean-deep)" }} data-testid="experiences-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-10 items-end mb-16">
          <div>
            <div className="overline mb-4">A experiência</div>
            <h2 className="font-display text-4xl md:text-5xl font-light leading-tight">
              O que cabe em quatro dias entre céu e mar.
            </h2>
          </div>
          <p className="text-base" style={{ color: "var(--ocean-muted)" }}>
            {EXPERIENCE_INTRO}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {EXPERIENCES.map((exp, idx) => (
            <motion.div
              key={exp.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.08 }}
              className="group relative h-[360px] overflow-hidden cursor-pointer lift"
              style={{ border: "1px solid var(--ocean-border)" }}
              data-testid={`experience-card-${idx}`}
            >
              <img
                src={IMAGES[exp.img]}
                alt={exp.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                style={exp.objectPosition ? { objectPosition: exp.objectPosition } : undefined}
              />
              <div
                className="absolute inset-0"
                style={{ background: "linear-gradient(180deg, rgba(4,11,22,0.1) 0%, rgba(4,11,22,0.92) 90%)" }}
              />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="overline mb-2">0{idx + 1}</div>
                <h3 className="font-display text-2xl font-medium mb-2">{exp.title}</h3>
                <p className="text-sm" style={{ color: "var(--ocean-muted)" }}>
                  {exp.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experiences;
